import { useCallback } from 'react';
import useAxiosInstance from './axiosInstance';

/**
 * Custom hook to delete files from the server.
 * @param {function} navigate - Function to navigate to another page.
 * @returns {object} Object containing deleteFile and deleteFiles functions.
 */
const useFileDelete = (navigate, container_name=null) => {
  const axiosInstance = useAxiosInstance(navigate);

  const deleteFile = useCallback(async (fileName) => {
    try {
      const response = await axiosInstance.delete(container_name ? `/deletefile?container=${container_name}` : '/deletefile', {
        data: { fileName }, // Pass the file name in the request body
      });
      return response.data;
    } catch (error) {
      console.error(`Error deleting file: ${fileName}`, error);
      throw error;
    }
  }, [axiosInstance, container_name]);

  const deleteFiles = useCallback(async (fileNames, onProgress, batchSize = 5) => {
    console.log("deletefiles", fileNames);
    const totalFiles = fileNames.length;
    let deletedFiles = 0;

    const updateProgress = () => {
      const percentCompleted = Math.round((deletedFiles / totalFiles) * 100);
      if (onProgress) onProgress(percentCompleted);
    };

    const deleteBatch = async (batch) => {
      await Promise.all(
        batch.map((fileName) =>
          deleteFile(fileName).then(() => {
            deletedFiles += 1;
            updateProgress();
          })
        )
      );
    };

    for (let i = 0; i < fileNames.length; i += batchSize) {
      const batch = fileNames.slice(i, i + batchSize);
      await deleteBatch(batch);
    }
  }, [deleteFile]);

  return { deleteFile, deleteFiles };
};

export default useFileDelete;
